import React from 'react';
import './BoardOfDirectors.css';

const directors = [
  {
    name: 'Open Seat',
    title: 'Independent Director',
    credentials: '',
    bio: 'Position open. Nexus Concordat is assembling additional independent directors as the family scales into clinical, regulatory, and commercial milestones.',
    placeholder: true,
  },
];

const advisors = [
  {
    name: 'Coming Soon',
    title: 'Advisor',
    credentials: '',
    bio: 'Position open. We are assembling domain experts in regulatory affairs, neuroscience, and AI governance.',
    placeholder: true,
  },
  {
    name: 'Coming Soon',
    title: 'Advisor',
    credentials: '',
    bio: 'Position open. We are assembling domain experts in regulatory affairs, neuroscience, and AI governance.',
    placeholder: true,
  },
  {
    name: 'Coming Soon',
    title: 'Advisor',
    credentials: '',
    bio: 'Position open. We are assembling domain experts in regulatory affairs, neuroscience, and AI governance.',
    placeholder: true,
  },
];

function MemberCard({ member, large = false }) {
  return (
    <div className={`bod-card${large ? ' bod-card-large' : ''}${member.placeholder ? ' bod-placeholder' : ''} reveal`}>
      <div className="bod-avatar">
        {member.placeholder
          ? <div className="bod-avatar-empty" />
          : <img src={member.photo} alt={member.name} />
        }
      </div>
      <div className="bod-info">
        <h4 className="bod-name">{member.name}</h4>
        <span className="bod-title">{member.title}</span>
        {member.credentials && <span className="bod-credentials">{member.credentials}</span>}
        <p className="bod-bio">{member.bio}</p>
      </div>
    </div>
  );
}

function BoardOfDirectors() {
  return (
    <section className="bod-section">
      <div className="bod-inner">

        {/* Board of Directors */}
        <div className="bod-group">
          <span className="section-label reveal">Governance</span>
          <h2 className="section-title reveal">Board of Directors</h2>
          <p className="bod-intro reveal">
            Non-founder directors responsible for strategic oversight, regulatory compliance,
            and ensuring Nexus Concordat&rsquo;s mission stays anchored in scientific integrity.
          </p>
          <div className="bod-grid">
            {directors.map((d, i) => <MemberCard key={i} member={d} />)}
          </div>
        </div>

        <div className="bod-divider" />

        {/* Advisory Board */}
        <div className="bod-group">
          <span className="section-label reveal">Domain Expertise</span>
          <h2 className="section-title reveal">Advisory Board</h2>
          <p className="bod-intro reveal">
            Subject matter experts in regulatory affairs, neuroscience, pharmacology,
            and AI governance who provide specialized guidance on technical and strategic decisions.
          </p>
          <div className="bod-grid">
            {advisors.map((a, i) => <MemberCard key={i} member={a} />)}
          </div>
        </div>

      </div>
    </section>
  );
}

export default BoardOfDirectors;
